import { useCallback } from 'react'
import logger, { LOG_NAME } from '../../../utils/logger'
import { useReportInputData } from './useReportInputData'

export const useOnPressButtons = () => {
  const reportQuery = useReportInputData()
  const userId = reportQuery?.data?.report?.user_id || ''
  const url_sale_base = 'https://aspect-health.com/metabolic-health'
  const full_url = `${url_sale_base}?utm_source=glucose_report&utm_content=glucose_report_${userId}`

  const onPressLandingPage = useCallback(() => {
    window?.open(full_url, '_blank')?.focus()
  }, [userId])

  const handlePressButtonIndex = useCallback(
    (index: number) => {
      //todo memoize callback
      return () => {
        logger.trackEvent(LOG_NAME.sales_button_press, { index, url_sale_base, full_url })
        onPressLandingPage()
      }
    },
    [userId],
  )

  return { handlePressButtonIndex }
}
